import api from './api';

export const getTodayCheckin   = ()        => api.get('/checkins/today', {
  params: { tz: Intl.DateTimeFormat().resolvedOptions().timeZone },
}).then(r => r.data);
export const getRecentCheckins = (days=7)  => api.get(`/checkins/recent?days=${days}`).then(r => r.data);
export const getCheckinStatus  = ()        => api.get('/checkins/status').then(r => r.data);
export const submitCheckin     = (data)    => api.post('/checkins', data).then(r => r.data);
